import { render } from "./NcrmOnboardingDetails.vue?vue&type=template&id=3952beab&scoped=true"
import script from "./NcrmOnboardingDetails.vue?vue&type=script&lang=js"
export * from "./NcrmOnboardingDetails.vue?vue&type=script&lang=js"

import "./NcrmOnboardingDetails.vue?vue&type=style&index=0&id=3952beab&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3952beab"]])

export default __exports__